<template>
<div class="chapter">
<div class="inner_page">
<div aria-label="9" epub:type="pagebreak" id="page9" role="doc-pagebreak">
</div>
<div class="Basic-Text-Frame" id="_idContainer011">
<p class="part-number-with-part-title" id="_idParaDest-1"><span class="bold">Part One:</span></p>
<p class="part-title-with-part-number"><span class="bold">STONE BLOSSOMS</span></p>
<p class="part-ornament"><span class="bold">North Hollywood</span></p>
<p class="part-ornament"><span class="bold">Summer, 1977</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781504096065-1.vue?2d6afc09